import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { Link } from 'react-router-dom';

const services = [
  {
    id: 'consulting',
    label: '01',
    tag: 'Consulting',
    title: '各種コンサルティング業務',
    subtitle: 'メイン事業',
    desc: '経営・戦略・業務改善から財務、マーケティングまで。貴社の現状を深く分析し、実行可能な打ち手を共に設計します。データドリブンなアプローチと豊富な現場経験を組み合わせ、確実な成果へと導きます。',
    points: ['経営戦略の立案・実行支援', '業務プロセスの改善・効率化', '市場調査・競合分析', '新規事業・参入戦略'],
    img: 'https://readdy.ai/api/search-image?query=business%20strategy%20consulting%20professional%20boardroom%20meeting%20data%20analysis%20charts%20modern%20office%20clean%20warm%20neutral%20tones%20Japan%20corporate&width=700&height=480&seq=srv-detail-1&orientation=landscape',
    bg: '#F5F2ED',
    accent: '#C8501A',
  },
  {
    id: 'advertising',
    label: '02',
    tag: 'Advertising',
    title: '広告業',
    subtitle: 'メイン事業',
    desc: 'デジタル広告・SNS・Web・OOHを横断した統合マーケティング施策を立案から実行まで一気通貫でサポート。ターゲット設計から効果検証まで、ROIを最大化するクリエイティブ戦略を提供します。',
    points: ['デジタル広告（SNS・リスティング）', 'クリエイティブ制作・ブランディング', 'PRプランニング', 'KPI設計・効果測定'],
    img: 'https://readdy.ai/api/search-image?query=advertising%20marketing%20agency%20creative%20design%20campaign%20planning%20modern%20workspace%20warm%20lighting%20professional%20Japan%20minimal&width=700&height=480&seq=srv-detail-2&orientation=landscape',
    bg: '#0A0E1A',
    accent: '#C8501A',
  },
  {
    id: 'space-design',
    label: '03',
    tag: 'Space Design',
    title: '店舗・空間デザイン',
    subtitle: '',
    desc: '店舗コンセプトの策定から内装デザイン、施工管理まで一貫してサポート。顧客体験を中心に据えた空間づくりで、ブランド価値と集客力を高めます。東京・首都圏を中心に、地域特性を踏まえた空間づくりをご提案します。',
    points: ['店舗コンセプト設計', '内装・外装デザイン', '施工管理・工程管理', 'リノベーション・改装'],
    img: 'https://readdy.ai/api/search-image?query=modern%20minimalist%20retail%20store%20interior%20design%20Japan%20warm%20wood%20clean%20elegant%20commercial%20space%20professional&width=700&height=480&seq=srv-detail-3&orientation=landscape',
    bg: '#F5F2ED',
    accent: '#C8501A',
  },
  {
    id: 'hr',
    label: '04',
    tag: 'HR Development',
    title: '人材育成関連事業',
    subtitle: '',
    desc: '個人の強みを引き出すコーチング、チームの連携を強化するワークショップ、組織文化を根本から変革する研修プログラムを設計・実施します。人こそが最大の資産という信念のもと、持続的な成長を支援します。',
    points: ['マネジメント・リーダー研修', 'チームビルディング', '採用・定着支援', '組織開発コンサルティング'],
    img: 'https://readdy.ai/api/search-image?query=team%20training%20workshop%20human%20resources%20professional%20development%20Japanese%20corporate%20bright%20collaborative%20office&width=700&height=480&seq=srv-detail-4&orientation=landscape',
    bg: '#0A0E1A',
    accent: '#C8501A',
  },
];

export default function ServicesPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Page Hero */}
      <section className="w-full bg-[#0A0E1A] pt-32 pb-16 px-6 md:px-16 relative overflow-hidden">
        <div className="absolute inset-0 opacity-5 pointer-events-none select-none flex items-center justify-center">
          <p className="text-[200px] font-black text-white tracking-tighter whitespace-nowrap">SERVICES</p>
        </div>
        <div className="relative z-10">
          <p className="text-xs tracking-[0.3em] text-[#C8501A] uppercase mb-4">Our Services</p>
          <h1 className="text-4xl md:text-6xl font-black text-white leading-tight">
            サービス内容
          </h1>
          <p className="text-sm text-white/50 mt-4 max-w-lg">
            4つの専門領域から、貴社の課題に最適なソリューションをご提案します。
          </p>
        </div>
      </section>

      {/* Services detail */}
      {services.map((s, idx) => (
        <section
          key={s.id}
          className="w-full"
          style={{ backgroundColor: s.bg }}
        >
          <div className="w-full px-6 md:px-16 py-16 md:py-24">
            <div className={`flex flex-col lg:flex-row gap-12 items-center ${idx % 2 === 1 ? 'lg:flex-row-reverse' : ''}`}>
              {/* Image */}
              <div className="w-full lg:w-1/2">
                <div className="w-full h-72 md:h-96 rounded-2xl overflow-hidden">
                  <img
                    src={s.img}
                    alt={s.title}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>

              {/* Text */}
              <div className="w-full lg:w-1/2">
                <div className="flex items-center gap-3 mb-4">
                  <span className="text-5xl font-black" style={{ color: s.bg === '#0A0E1A' ? '#ffffff10' : '#0A0E1A10' }}>
                    {s.label}
                  </span>
                  <span className="inline-block px-3 py-1 text-xs font-medium rounded-full" style={{ backgroundColor: '#C8501A20', color: '#C8501A' }}>
                    {s.tag}
                  </span>
                  {s.subtitle && (
                    <span className="inline-block px-3 py-1 text-xs font-medium rounded-full" style={{ backgroundColor: '#C8501A', color: 'white' }}>
                      {s.subtitle}
                    </span>
                  )}
                </div>

                <h2 className={`text-2xl md:text-3xl font-black leading-tight mb-4 ${s.bg === '#0A0E1A' ? 'text-white' : 'text-[#0A0E1A]'}`}>
                  {s.title}
                </h2>
                <p className={`text-sm leading-relaxed mb-6 ${s.bg === '#0A0E1A' ? 'text-white/60' : 'text-[#6B6560]'}`}>
                  {s.desc}
                </p>

                <ul className="space-y-2 mb-8">
                  {s.points.map((pt) => (
                    <li key={pt} className="flex items-center gap-3">
                      <span className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                        <i className="ri-checkbox-circle-line text-[#C8501A]" />
                      </span>
                      <span className={`text-sm ${s.bg === '#0A0E1A' ? 'text-white/70' : 'text-[#6B6560]'}`}>{pt}</span>
                    </li>
                  ))}
                </ul>

                <Link
                  to="/contact"
                  className="inline-flex items-center gap-2 px-6 py-3 bg-[#C8501A] text-white text-sm font-medium rounded-full hover:bg-[#A83E10] transition-colors cursor-pointer whitespace-nowrap"
                >
                  このサービスについて相談する <i className="ri-arrow-right-line" />
                </Link>
              </div>
            </div>
          </div>
        </section>
      ))}

      {/* CTA */}
      <section className="w-full bg-white py-16 px-6 md:px-16 text-center">
        <p className="text-xs tracking-[0.3em] text-[#C8501A] uppercase mb-3">Contact</p>
        <h3 className="text-2xl md:text-3xl font-black text-[#0A0E1A] mb-4">お気軽にご相談ください</h3>
        <p className="text-sm text-[#6B6560] mb-8">まずは無料相談から。お客様のご状況を丁寧にお聞きします。</p>
        <Link
          to="/contact"
          className="inline-flex items-center gap-2 px-8 py-3.5 bg-[#0A0E1A] text-white text-sm font-medium rounded-full hover:bg-[#C8501A] transition-colors cursor-pointer whitespace-nowrap"
        >
          お問い合わせ <i className="ri-arrow-right-line" />
        </Link>
      </section>

      <Footer />
    </div>
  );
}
